import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, switchMap } from 'rxjs';
import { UserService } from '../user/user.service';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class SignerService {
  constructor(private http: HttpClient, private userService: UserService) {}

  getSigners(): Observable<any> {
    return this.userService.getUserInfo().pipe(
      switchMap(user => {
        const headers = new HttpHeaders({
          'message-id': crypto.randomUUID(),
          'entity-doc-type': user['custom:tipoDocEntidad'],
          'entity-doc-number': user['custom:numeroDocEntidad'],
          'Authorization': `Bearer ${localStorage.getItem('id_token')}`
        });

        return this.http.get(environment.signersByEntityUrl, { headers });
      })
    );
  }

}